import TYPE from "../../../constant/TYPE";
import Provider from "./Provider";
import Node from "./Node";
import AnsweringQuestionsNode from "./AnsweringQuestionsNode";
import CheckWrongAnswerNode from "./CheckWrongAnswerNode";

const MathJax = {
  Provider,
  Node,
  AnsweringQuestionsNode,
  CheckWrongAnswerNode
};

const getMathJaxNode = ( type ) => {
  switch ( type ) {
    case TYPE.MATHJAX.ANSWERING_QUESTIONS :
      return AnsweringQuestionsNode;
    case TYPE.MATHJAX.CHECK_WRONG_ANSWER :
      return CheckWrongAnswerNode;
    default :
      return Node;
  }
};

export default MathJax;
export {
  getMathJaxNode,
  Provider,
  Node,
  AnsweringQuestionsNode,
  CheckWrongAnswerNode
};
